import Vue from 'vue'
import Vuex from 'vuex'
import worktime from './modules/worktime' 
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    worktime
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})